<script lang="ts">
  import type {
    PublicContactMethodChannel,
    PublicContactMethodResponse,
  } from "../../../../../../api/public/appointment-portal"
  import ContactMethodRow from "./_modules/contact-method-row"

  const {
    contactMethods,
    pendingChannelKey = null,
    rowMessageById = {},
    onSetChannelPermission,
    onRequestDeletion,
  } = $props<{
    contactMethods: PublicContactMethodResponse[]
    pendingChannelKey?: string | null
    rowMessageById?: Record<string, string>
    onSetChannelPermission: (
      method: PublicContactMethodResponse,
      channel: PublicContactMethodChannel,
      isEnabled: boolean,
    ) => Promise<void> | void
    onRequestDeletion: (method: PublicContactMethodResponse) => void
  }>()
</script>

<div class="contact-method-list">
  {#each contactMethods as method (method.id)}
    <ContactMethodRow
      {method}
      {pendingChannelKey}
      rowMessage={rowMessageById[method.id] ?? ""}
      {onSetChannelPermission}
      {onRequestDeletion}
    />
  {/each}
</div>

<style lang="less">
  .contact-method-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
